/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Submit_CreateInputs */

const he_notifications_submit_create = /** @type {(inputs: Notifications_Submit_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבלת התראה`)
};

const en_notifications_submit_create = /** @type {(inputs: Notifications_Submit_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Notification`)
};

/**
* | output |
* | --- |
* | "Enable Notification" |
*
* @param {Notifications_Submit_CreateInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_submit_create = /** @type {((inputs?: Notifications_Submit_CreateInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Submit_CreateInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_submit_create(inputs)
	return en_notifications_submit_create(inputs)
});